import React from 'react';
import { svgSprite } from '../../../../../../../../../hybrid/wrappers';
import Cart from '../../../../../../../../../widgets/cart/Cart/Cart';
import css from './Order.module.scss';

const CartOrder = ({ formDataError, setFormDataError, products }) => {
    return (
        <div>
            {formDataError && formDataError.items && (
                <div className={css.errorTitle}>
                    {svgSprite('warning-circle', {
                        width: '12px',
                        height: '12px',
                        style: { paddingBottom: '13px' },
                        fill: 'var(--redColor)'
                    })}
                    {formDataError.items.map((err, idx) => (
                        <div key={`errItem${idx}`} style={{ paddingLeft: '5px' }}>
                            {err}
                        </div>
                    ))}
                </div>
            )}
            {formDataError && formDataError.quantity && (
                <div className={css.errorTitle}>
                    {svgSprite('warning-circle', {
                        width: '12px',
                        height: '12px',
                        style: { paddingBottom: '13px' },
                        fill: 'var(--redColor)'
                    })}
                    {formDataError.quantity.map((err, idx) => (
                        <div key={`errItem${idx}`} style={{ paddingLeft: '5px' }}>
                            {err}
                        </div>
                    ))}
                </div>
            )}
            <Cart
                products={products}
                funcs={{
                    onError: (error) => {
                        if (error?.errors) {
                            setFormDataError((s) => ({
                                ...s,
                                ...error?.errors
                            }));
                        }
                    }
                }}
            />
            {/* <CartFooter
                type='checkout'
                total={cartData.total_price_formatted}
                total_marketing={cartData.total_marketing_price_formatted}
            /> */}
        </div>
    );
};
export default CartOrder;
